const formatSingleUser = (singleUserName) => {
	if (singleUserName.toLocaleLowerCase() === "agroinventario") {
		return "Agro";
	}

	const connectors = new Set(["de", "la", "del", "los", "las", "el", "y"]);

	const parts = singleUserName
		.trim()
		.split(/\s+/)
		.filter((part) => !connectors.has(part.toLowerCase()));

	if (parts.length === 0) {
		return "";
	}

	if (parts.length === 1) {
		return parts[0];
	}

	if (parts.length === 2) {
		return `${parts[0].charAt(0).toUpperCase()}. ${parts[1]}`;
	}

	if (parts.length === 3) {
		return `${parts[0].charAt(0).toUpperCase()}. ${parts[2]}`;
	}

	const firstInitial = parts[0].charAt(0).toUpperCase();
	const penultimate = parts.at(-2);
	return `${firstInitial}. ${penultimate}`;
};

export const formatUser = (user_name) => {
	if (!user_name || typeof user_name !== "string") {
		return { abbreviated: "", full: "" };
	}

	const normalizedFullName = user_name
		.split(",")
		.map((singleUserName) => singleUserName.trim())
		.filter(Boolean)
		.join(", ");

	if (!normalizedFullName) {
		return { abbreviated: "", full: "" };
	}

	const abbreviated = normalizedFullName
		.split(",")
		.map((singleUserName) => formatSingleUser(singleUserName.trim()))
		.filter(Boolean)
		.join(", ");

	return { abbreviated, full: normalizedFullName };
};
